import { AlertTriangle } from "lucide-react";

export function MockDataBanner({ className }: { className?: string }) {
  return (
    <div
      className={`flex items-center gap-2 rounded-md border border-warning-border bg-warning-soft px-3 py-2 text-xs font-medium text-warning ${className ?? ""}`}
      role="status"
    >
      <AlertTriangle className="size-3.5 shrink-0" aria-hidden />
      <span>
        This page uses <strong>mock data</strong> for demonstration. Connect to a
        live Alloy backend to see real data.
      </span>
    </div>
  );
}
